import React from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

interface SnGroupLabelProps {
  text: string;
  inputRef?: any;
  onFocus?: (target: string) => void;
}

export function SnGroupLabel({ text, inputRef, onFocus }: SnGroupLabelProps) {
  const handleFocus = () => {
    onFocus && onFocus("next");
  };

  return (
    // <div
    //   className="shadow-[0px_1px_0px_0px_rgb(11,12,105)]"
    //   ref={inputRef}
    //   onFocus={handleFocus}
    //   tabIndex={-1}
    //   style={{
    //     color: "rgb(11,12,105)",
    //     height: "30px",
    //     fontWeight: "bold",
    //     // fontSize: "17px",
    //   }}
    // >
    //   <FiberManualRecordIcon
    //     sx={{
    //       color: "rgb(11,12,105)",
    //       fontSize: "8px",
    //       marginRight: "5px",
    //     }}
    //   />
    //   {text}
    // </div>
    <div
      className="flex items-center w-full"
      ref={inputRef}
      onFocus={handleFocus}
      tabIndex={-1}
    >
      <span
        className="mr-2 whitespace-nowrap font-bold"
        style={{ color: "rgb(11,12,105)" }}
        tabIndex={-1}
      >
        <FiberManualRecordIcon
          tabIndex={-1}
          sx={{
            color: "rgb(11,12,105)",
            fontSize: "8px",
            marginRight: "5px",
          }}
        />
        {text}
      </span>
      <div
        className="border-t flex-1"
        style={{ borderColor: "rgb(11,12,105)" }}
        tabIndex={-1}
      ></div>
    </div>
  );
}

export default React.memo(SnGroupLabel);
